import React from 'react'
import { CardDrawer } from '.';
import DiaryAlert from '../DiaryAlert';
import Button from '../inputs/Button';
import Icon from '../Icon';
import Divider from '../Divider';
import { StyledCardList } from './styled';

function CardList({ data, cmp: ContentDrawer, urgent, showOpenButton }) {
    return (
        <StyledCardList>
            {data && data.map((item, index) => (
                <li key={item.rowid || index}>
                    <CardDrawer
                        name={<DiaryAlert alert={item} urgent={urgent} manual={item.manual} />}
                        renderOpenButton={({ handleToggleIsOpenDrawer }) => (showOpenButton && <Button noMargin onClick={handleToggleIsOpenDrawer} showOpenButton><Icon name='add_note' /></Button>)}
                        renderContentDrawer={({ handleToggleIsOpenDrawer }) => <ContentDrawer handleToggleIsOpenDrawer={handleToggleIsOpenDrawer} rowid={item.rowid} note={item.note} />}
                    />
                    {index < data.length - 1 && <Divider />}
                </li>
            ))}
        </StyledCardList>
    )
}

export default CardList
